import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const EttOptionsUI = (props: UIProperties<EttOptionsUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '870px',
				height: '680px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '870px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='ett-options-top' aria-label='E T T Options'>ETT Options</p>
				</div>
				<div style={{
					width: '100%',
					height: '610px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					
					<CustomEttOptionsSlider></CustomEttOptionsSlider>

					<GeneralButtonWithText parameters= {{
						text: 'Next',
						ariaLbl: 'Next',
						id: 'ett-options-bottom',
						top: '480px',
						left: '340px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.OnNextClicked(selectedDepth)
						}
					}}/>
				</div>
				
			</div>
		</div>
	);
};

const sliderKnobId = Tools.generateGuid();
const sliderKnob2Id = Tools.generateGuid();
const sliderKnobParentId = Tools.generateGuid();
var isHoveringOverBg = false;
var selectedIndx = 0;
var selectedDepth = 0;
var inited = false;

const CustomEttOptionsSlider = () => {
	const availableXPos= [
		50,
		216,
		379,
		542,
		702
	];

	const items = [1, 2, 3, 4, 5];

	const [xPos, setXPos] = useState(0);
	const [isDragging, setIsDragging] = useState(false);

	const mouseMoveMethod = (event: MouseEvent) => { 
		// (window as any)['currentInsertionAngleSliderDragData'] = {
		// 	top: event.clientY,
		// 	left: event.clientX,
		// 	img: (window as any)['currentDraggedItemPositionData'].img
		// }  
		// var el = document.getElementById(sliderKnobId)
		// el.style.top = 'px';
		if(isHoveringOverBg) {
			if(!inited) {
				var el = document.getElementById(sliderKnobId)
				var el2 = document.getElementById(sliderKnob2Id);
				var scale = el2.getBoundingClientRect().width / el2.offsetWidth;
				el.style.transform = 'translate(-50%, -50%) scale(' + scale + ')'
				el.style.visibility = 'visible';

				el.style.top = ($('#' + sliderKnob2Id).offset().top + (40 * scale)) + 'px';
				
				document.body.appendChild(el);
				el2.style.visibility = 'hidden'
				console.log(document.getElementById(sliderKnob2Id))
				inited = true;
			}
			
			setXPos(event.clientX);
		}
	};

	const mouseUpMethod = () => { 
		// (window as any)['currentInsertionAngleSliderDragData'] = {
		// 	top: 0,
		// 	left: 0
		// }
		setIsDragging(false);
		var el = document.getElementById(sliderKnobId);
		document.getElementById(sliderKnobParentId).appendChild(el);

		el.style.visibility = 'hidden'

		var el2 = document.getElementById(sliderKnob2Id);
		el2.style.visibility = 'visible'

		el2.style.left = (availableXPos[selectedIndx] - 40) + 'px';
		inited = false;
		selectedDepth = items[selectedIndx];

		// setDataBeingDragged(null);
		window.removeEventListener('mousemove', mouseMoveMethod);
		window.removeEventListener('mouseup', mouseUpMethod);
	};

	return (
		<div style={{
			position: 'absolute',
			top: '141px',
			left: '50%',
			width: '750px',
			height: '190px',
			transform: 'translate(-50%, 0)'
		}}>
			{/* <p className='title-font' style={{
				textAlign: 'center',
				margin: '0',
				fontSize: '18pt',
				fontWeight: 'normal'
			}}>Insertion Depth (cm) from Cricothyroid Membrane</p> */}

			<p className='title-font' style={{
				textAlign: 'center',
				margin: '0',
				fontSize: '18pt',
				fontWeight: 'normal'
			}} tabIndex={0}>Endotracheal tube insertion depth of cuff past skin.</p>
			<div style={{
				position: 'relative',
				left: '50%',
				transform: 'translate(-50%, 0)',
				width: '100%',
				top: '70px'
			}}>
				<div style={{
					border: '3px solid rgb(192, 161, 6)',
					backgroundColor: 'rgb(0, 85, 178)',
					width: '100%',
					height: '40px'
				}}>
				</div>
				<div style={{
					backgroundColor: 'transparent',
					width: '100%',
					height: '40px',
					position: 'absolute',
					top: '0',
					left: '50%',
					transform: 'translate(-50%, 0)',
					pointerEvents: 'all'
				}} tabIndex={0} aria-label={'Current Depth. ' + items[selectedIndx]}  onMouseOver={() => {
					if(!isHoveringOverBg) {
						isHoveringOverBg = true;
					}
				}} onMouseOut = {() => {
					if(isHoveringOverBg) {
						isHoveringOverBg = false;
					}
				}} onMouseDown={() => {
					if(!isDragging) {
						setIsDragging(true);
						
						// (window as any)['currentInsertionAngleSliderDragData'] = {
						// 	top: -1000,
						// 	left: -1000
						// }
						window.addEventListener('mousemove', mouseMoveMethod);
						window.addEventListener('mouseup', mouseUpMethod);
					}
				}}  id={sliderKnobParentId}>
					<div style={{
						height: '80px',
						width: '80px',
						position: 'absolute',
						left: xPos,
						pointerEvents: 'none',
						visibility: 'hidden'
					}} id={sliderKnobId}>
						<img style={{
							pointerEvents: 'none',
							height: '80px',
						}} src='./assets/images/cric/insertion-angle/slider_circle.png' />
					</div>
					<div style={{
						height: '80px',
						width: '80px',
						position: 'relative',
						top: '-20px',
						left: xPos
					}}  id={sliderKnob2Id}>
						<img style={{
							pointerEvents: 'none',
							height: '80px'
						}} 
						src='./assets/images/cric/insertion-angle/slider_circle.png' />
					</div>
					<div style={{
						width: '100%',
						height: '100%',
						position: 'absolute',
						top: '0',
						left: '0',
						display: 'grid',
						gridTemplateColumns: 'auto auto auto auto auto'
					}}>
						{items.map((el: number, indx: number) => {
							return <div style={{
								// backgroundColor: 'rgb(' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) +')'
							}}  tabIndex={0} aria-label={el.toString()} role='button' onKeyUp={mapDivEnterToClick} onClick={() => {
								selectedIndx = indx;
								selectedDepth = items[selectedIndx];
								mouseUpMethod();
							}} onMouseOver={() => {
								selectedIndx = indx;
							}}></div>
						})}
					</div>
				</div>

				<div style={{
					backgroundColor: 'transparent',
					width: '100%',
					height: '40px',
					position: 'relative',
					top: '30px'
				}}>
					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '40px'
					}}>1</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '206px'
					}}>2</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '369px'
					}}>3</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '532px'
					}}>4</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '692px'
					}}>5</p>
				</div>
			</div>
		</div>
	);
}

export interface EttOptionsUIConfig extends BaseConfig{
	OnNextClicked: (selectedDepth: number) => void;
}

export default EttOptionsUI;